import { Typography } from "antd";
import React from "react";

const OrganizationSettingsPageTitle = () => {
  return (
    <div className="dashboard-page-title">
      <Typography.Title level={4} style={{ margin: 0 }}>
        Organization Settings
      </Typography.Title>
    </div>
  );
};

export default OrganizationSettingsPageTitle;
